import './homePro.css';

function HomePro() {
  return (
    <div>
        {/* Header supprimé */}
    </div>
  );
}

export default HomePro;
